import {Component, ComponentInterface, h, Prop, Event, EventEmitter, State} from '@stencil/core';
import {AllowedTypes} from '../../utils';
import {defaultMap, propMap} from './density-map';
import {SolButtonSize, SolButtonSizeEnum, SolButtonVariant, SolButtonVariantEnum} from './types';

@Component({
  tag: 'sol-button',
  styleUrls: {medium: 'sol-button.scss', low: 'sol-button.low.scss'},
})
export class SolButton implements ComponentInterface {
  @Prop() size: SolButtonSize = SolButtonSizeEnum.Medium;

  @Prop() variant: SolButtonVariant = SolButtonVariantEnum.Primary;

  @Prop() disabled: boolean = false;

  @Prop() isOpaque: boolean = false;

  @Prop() testId: string = '';

  @Prop() iconOnly: boolean = false;

  @Event({
    eventName: 'sol-click',
  })
  clickEventEmitter?: EventEmitter<MouseEvent>;

  @State() activeFocus: boolean = false;

  private handleClickButton = (ev: MouseEvent) => {
    this.activeFocus = true;
    this.clickEventEmitter?.emit(ev);
  };

  private loseFocus(): void {
    this.activeFocus = false;
  }

  @AllowedTypes(propMap, defaultMap)
  componentDidLoad(): void {}

  render() {
    return (
      <button
        disabled={this.disabled}
        onClick={(e) => {
          this.handleClickButton(e);
        }}
        onMouseDown={() => {
          this.activeFocus = true;
        }}
        onBlur={() => {
          this.loseFocus();
        }}
        class={{
          'sol-button': true,
          [`sol-button-${this.variant}`]: true,
          [`sol-button-${this.size}`]: true,
          'sol-button--disabled': !!this.disabled,
          'sol-button--no-outline': this.activeFocus,
          'sol-button--is-opaque': this.isOpaque,
          [`sol-button--no-text`]: this.iconOnly,
        }}
        data-test-id={this.testId}
      >
        <slot></slot>
      </button>
    );
  }
}
